import browserHelper from '@utils/browser-helper';

class Storage {
  localStorage =
    browserHelper.isLocalStorageAvailable || browserHelper.areCookiesAvailable ? window.localStorage : null;

  private data: any = {};

  isInMemoryItem(key: string) {
    // token and tokenTTL fields are stored in memory
    const itemsToStoreInMemory = ['token', 'tokenTTL', 'isInForeground', 'refreshToken'];
    return itemsToStoreInMemory.indexOf(key) !== -1;
  }

  getItem(key: string) {
    if (this.isInMemoryItem(key)) {
      return this.data[key];
    }

    let valueAsString;
    if (browserHelper.isLocalStorageAvailable) {
      valueAsString = localStorage[key];
    } else {
      valueAsString = this.data[key];
    }

    try {
      // un-stringify if its object
      return JSON.parse(valueAsString);
    } catch (e) {
      // If its plain string JSON.parse() will fail
      return valueAsString;
    }
  }

  setItem(key: string, value: any) {
    if (this.isInMemoryItem(key)) {
      this.data[key] = value;
      return;
    }

    // If its object, stringify
    const valueAsString = typeof value === 'object' ? JSON.stringify(value) : value;
    if (browserHelper.isLocalStorageAvailable) {
      localStorage[key] = valueAsString;
    } else {
      this.data[key] = valueAsString;
    }
  }

  removeItem(key: string) {
    if (this.isInMemoryItem(key)) {
      delete this.data[key];
      return;
    }

    if (browserHelper.isLocalStorageAvailable) {
      delete localStorage[key];
    } else {
      delete this.data[key];
    }
  }
}

export const storage = new Storage();
